import { BLOG_URL } from '@app/config';
import { FaqAccordionItems } from '@app/widgets';

export const LIVE_UPDATES_FAQS: FaqAccordionItems[] = [
  {
    question: 'What are Live Updates?',
    answer: [
      'Live Updates, also known as Over-the-Air (OTA) or hot code updates, are a way to deliver updates to your app without the need to resubmit it to the app stores.',
      'This allows you to fix bugs, add new features or change the design of your app in real-time.',
      'Unlike traditional app updates that require users to download from app stores and can take days for review, Live Updates are delivered instantly via our global CDN.',
      'This dramatically reduces your time to market and allows you to respond quickly to issues or user feedback.',
    ].join(' '),
  },
  {
    question: 'Are Live Updates compliant with app store policies?',
    answer: [
      'Yes, Live Updates are fully compliant with both Apple App Store and Google Play Store policies.',
      'Our platform only modifies the web layer (HTML, CSS, JavaScript, and assets), which is explicitly permitted by both stores.',
      'Apple allows "interpreted code" downloads as long as they don\'t change the app\'s primary purpose, and Google Play exempts code running in webviews from self-update restrictions.',
      'Learn more in our <a href="https://capawesome.io/cloud/live-updates/faq/#general">Live Updates FAQ</a>.',
    ].join(' '),
  },
  {
    question: 'Are there any limitations for Live Updates?',
    answer: [
      'Yes, Live Updates are only supported for <a href="https://capawesome.io/cloud/live-updates/faq/#what-are-binary-compatible-changes" target="_blank">binary-compatible changes</a> (e.g. HTML, CSS, JavaScript, and assets).',
      'This is a general limitation of the Live Updates technology itself, not a limitation of our SDK or platform.',
      'If you change native code, such as adding a new Capacitor plugin or updating native dependencies, you need to resubmit your app to the app stores.',
      `For this reason, you must be careful to <a href="${BLOG_URL}how-to-restrict-capacitor-live-updates-to-native-versions/" target="_blank">restrict Live Updates to compatible native versions</a> of your app.`,
      'Feel free to reach out to us if you have any questions or need help with this.',
    ].join(' '),
  },
  {
    question: 'How quickly are updates delivered to users?',
    answer: [
      'Updates are delivered almost instantly.',
      'When you deploy a Live Update, it becomes available on our global CDN within seconds.',
      'Users will receive the update automatically the next time they open your app or when the app checks for updates in the background.',
      "The download time depends on the update size and the user's network connection, but most updates are just a few megabytes and download in seconds.",
    ].join(' '),
  },
  {
    question: 'Can I rollback an update if something goes wrong?',
    answer: [
      'Yes, you can easily rollback to a previous version at any time.',
      'Our platform maintains a complete history of all your Live Updates, allowing you to instantly revert to any previous version if you discover an issue.',
      'You can also configure automatic rollback policies based on error rates or custom metrics to protect your users.',
      'Rollbacks are deployed just as quickly as regular updates, typically taking effect within seconds.',
    ].join(' '),
  },
];
